import { Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PostRequestBase,
  ResponseBase,
  ScreenModel,
  RequestData } from '../../../../core/models/common';
import {
  ContactPerson,
  ContactPersonServerData,
  Organization,
  OrganizationServerData,
  Product,
  ProductOption,
  ProductOptionServerData,
  ProductServerData,
  Workflow,
} from '../../../../core/models/fna';
import { ApiService } from '../../../../core/services/api-mock.service';
import { GlobalsService } from '../../../../core/services/globals.service';
import { SideBarService } from '../../../../core/services/side-bar.service';
import {
  riskDeclaredLessThanRiskAssessed,
  riskDeclaredMoreThanRiskAssessed,
  riskDeclaredNotEqualRiskAssessed,
} from '../../../../core/utilities/riskAssessment';
import { SharedAPIService } from '../../../../core/services/shared-api.service';
import { async } from '@angular/core/testing';

// What we receive from the API when page is loaded
export interface ReviewAndSubmitData extends ResponseBase {
  Organization: OrganizationServerData;
  ContactPerson: ContactPersonServerData;
  TreasuryAdvisorName: string;
  LastFNADate: string;
  DeclaredRiskProfile: string;
  AssessedRiskProfile: string;
  IsAcceptAssessedRiskProfile: boolean;
  NonRecommendedProductsOptions: ProductOptionServerData[];
  RecommendedProductsOptions : ProductOptionServerData[];
  IsAcceptRecommendedProducts: boolean;
  IsPurchaseTableBProducts: boolean;
  DeclarationNote: string;
  IsAcknowledgeDeclaration: boolean;
  IsAcknowledgeProductRisk: boolean;
  IsAcknowledgeRiskDisclosure: boolean;
}

// What we will send to the API when submit
export interface ReviewAndSubmitRequestData extends PostRequestBase {
  IsAcknowledgeDeclaration: boolean;
  IsAcknowledgeProductRisk: boolean;
  IsAcknowledgeRiskDisclosure: boolean;
}

export class ReviewAndSubmitModel extends ScreenModel {
  screenName = 'ReviewAndSubmit';
  pageID_read = 'R0090';
  pageID_write = 'S0091';
  pageID_docusign = 'S0090'
  data: ReviewAndSubmitData | undefined;
  organization: Organization | undefined;
  contactPerson: ContactPerson | undefined;
  treasuryAdvisorName: string | undefined;
  lastFNADate: string | undefined;
  declaredRiskProfile: string | undefined;
  assessedRiskProfile: string | undefined;
  isAcceptAssessedRiskProfile: boolean | undefined;
  recommendedProducts: ProductOption[] = [];
  nonRecommendedProductsOptions: ProductOption[] = [];
  isAcceptRecommendedProducts: boolean | null = null;
  isPurchaseTableBProducts: boolean | null = null;
  declarationNote: string | undefined;
  isAcknowledgeDeclaration: boolean = false;
  isAcknowledgeProductRisk: boolean = false;
  isAcknowledgeRiskDisclosure: boolean = false;
  docuSignURL: string | null = null;
  sharedAPIService : any
  docusignWarningMessage : string = 'You are being redirected to DocuSign'
  servlet_context_path = "";
  verifyDocusignResponse : any;
  recommendedProductsHolder : any;

  // Data lifecycle start.

  mapPegaObjToUI(data : any){
    console.log("FIRSTEVER MAPPING TEST +++++++")
    console.log(data)
    let customerDetails = data['CustomerDetails'];
    let riskandObjectiveDetails = data['RiskandObjectiveDetails'];
    const tableADescList = []//this.sharedAPIService.getTableABDesc()['tableA']
    const tableBDescList = []//this.sharedAPIService.getTableABDesc()['tableB']
    this.recommendedProductsHolder = this.sharedAPIService.getProductsFromPegaTable(data['ProductDetails']['TableA'])
    
     let reviewAndSubmitData:ReviewAndSubmitData  = {
      
      Organization: {
        CompanyName: customerDetails['Name']?customerDetails['Name']:'-',
        MainAddress: customerDetails['AddressDetails']['FullAddress']?customerDetails['AddressDetails']['FullAddress']:'-',
        TelephoneNo: customerDetails['ContactDetails']['PhoneNumber']?customerDetails['ContactDetails']['PhoneNumber']:'-',
        FaxNo: customerDetails['ContactDetails']['FaxNumber']?customerDetails['ContactDetails']['FaxNumber']:'-',
      },
      ContactPerson: { 
        OrganizationRepresentative:  customerDetails['ContactPersonDetails']['Name']?customerDetails['ContactPersonDetails']['Name']:'-',
        EmailAddress: customerDetails['ContactPersonDetails']['ContactDetails']['EmailAddress']?customerDetails['ContactPersonDetails']['ContactDetails']['EmailAddress']:'-',
        MobileNo: customerDetails['ContactPersonDetails']['ContactDetails']['PhoneNumber']?customerDetails['ContactPersonDetails']['ContactDetails']['PhoneNumber']:'-'
      },
      TreasuryAdvisorName: customerDetails['TreasuryAdvisorName']?customerDetails['TreasuryAdvisorName']:'-',
      LastFNADate: this.getUIDate(customerDetails['DateOfLastFNA'])!=""?this.getUIDate(customerDetails['DateOfLastFNA']):'-',
       DeclaredRiskProfile: riskandObjectiveDetails['DeclaredRiskProfile'],
      AssessedRiskProfile: riskandObjectiveDetails['AssessedRiskProfile'],
      IsAcceptAssessedRiskProfile: riskandObjectiveDetails['ReConsiderDeclaredRiskProfile']=='Yes'?true:(riskandObjectiveDetails['ReConsiderDeclaredRiskProfile']=='No'?false:false),
      //RecommendedProducts: this.sharedAPIService.getProductsFromPegaTable(data['ProductDetails']['TableA']),
      NonRecommendedProductsOptions: this.sharedAPIService.getProductsFromPegaTable(data['ProductDetails']['TableB']),
      RecommendedProductsOptions: this.sharedAPIService.getProductsFromPegaTable(data['ProductDetails']['TableA']),
      IsAcceptRecommendedProducts: data['ProductDetails']['AcceptProductsInTableA']=='Yes'?true:data['ProductDetails']['AcceptProductsInTableA']=='No'?false:false,
      IsPurchaseTableBProducts:  data['ProductDetails']['PurchaseOtherProductsInTableB']=='Yes'?true:data['ProductDetails']['PurchaseOtherProductsInTableB']=='No'?false:false,
     // DeclarationMessage: data['Declaration'],
      DeclarationNote: data['DeclarationNote'],
     
      IsAcknowledgeDeclaration: false,
      IsAcknowledgeProductRisk: false,
      IsAcknowledgeRiskDisclosure: false
  
     }
     return reviewAndSubmitData;
   }

  deriveFromData(data: ReviewAndSubmitData) {
    console.log('deriveFromData, model:', this);
    this.organization = {
      companyName: data.Organization.CompanyName,
      mainAddress: data.Organization.MainAddress,
      telephoneNo: data.Organization.TelephoneNo,
      faxNo: data.Organization.FaxNo,
    };
    this.contactPerson = {
      organizationRepresentative: data.ContactPerson.OrganizationRepresentative,
      emailAddress: data.ContactPerson.EmailAddress,
      mobileNo: data.ContactPerson.MobileNo,
    };
    this.treasuryAdvisorName = data.TreasuryAdvisorName;
    this.lastFNADate = data.LastFNADate;
    this.declaredRiskProfile = data.DeclaredRiskProfile;
    this.assessedRiskProfile = data.AssessedRiskProfile;
    this.isAcceptAssessedRiskProfile = data.IsAcceptAssessedRiskProfile;
    this.recommendedProducts = data.RecommendedProductsOptions.map(
      (product) => {
        return {
          id: product.Id,
          riskLevel: product.RiskLevel,
          title: product.Title,
          description: product.Description,
          shortDescription: product.ShortDescription,
          isChecked: product.IsChecked === true,
          hide : true
        };
      },
    );
    this.nonRecommendedProductsOptions = data.NonRecommendedProductsOptions.map((product) => {
      return {
        id: product.Id,
        riskLevel: product.RiskLevel,
        title: product.Title,
        description: product.Description,
	      shortDescription: product.ShortDescription,
        isChecked: product.IsChecked === true,
        hide:true
      };
    });
    this.isAcceptRecommendedProducts = data.IsAcceptRecommendedProducts;
    this.isPurchaseTableBProducts = data.IsPurchaseTableBProducts;
    this.declarationNote = data.DeclarationNote;
    this.isAcknowledgeDeclaration = data.IsAcknowledgeDeclaration;
    this.isAcknowledgeProductRisk = data.IsAcknowledgeProductRisk;
    this.isAcknowledgeRiskDisclosure = data.IsAcknowledgeRiskDisclosure;
  }

  deriveDataFromModel(): RequestData {
    // @For integration
   
    return {
      ServiceBody :{}
    };
  }

  deriveDataFromModelDocusign() : RequestData{
    console.log("return URL", window.location)
    //const contextPath = this.sharedAPIService.getServletContextPath();
    return {
      ServiceBody :{returnUrl :  window.location.origin + this.servlet_context_path,
                    IsAcknowledgeDeclaration  : true,  
                    IsAcknowledgeProductRisk : true,
                    IsAcknowledgeRiskDisclosure:true
      }
    };
  }

  syncModelWithForm() {
    console.log('[ReviewAndSubmitModel] syncModelWithForm');
    const formValues = this.form?.value;
    this.isAcknowledgeDeclaration = formValues.isAcknowledgeDeclaration;
    this.isAcknowledgeProductRisk = formValues.isAcknowledgeProductRisk;
    this.isAcknowledgeRiskDisclosure = formValues.isAcknowledgeRiskDisclosure;
  }

  validate() {
    if (!this.isSubmitted) {
      return;
    }

    if (!this.form) {
      return;
    }

    this.isValid = this.form.valid;
  }

  async onSubmit(){
    
    if(this.doNotSkipWriteService){
      const updateDataStatus = await this.submitData();
   
    if (updateDataStatus) {
      // @For integration: handle error.
      return;
    }
    }
    

   // this.form?.markAsPristine();

    this.goToNextScreen();
  }
  async submitData() {
    this.isLoading = true;
    const data = Object.assign(
      this.getDefaultPostRequest(),
      this.deriveDataFromModel(),
    );
    console.log('[ScreenModel] updateData, deriveDataFromModel, data:', data);

    // const status = await this.apiService.submitFNAInfo(data);
    // if (!status) {
    //   return status;
    // }
    const newData :PostRequestBase = Object.assign({},data,{ServiceHeader : {
      ...data.ServiceHeader,
      PageName : this.screenName,
      RequestID : this.pageID_write,
      TokenID : this.apiService.getTokenID()
    }})
 
    let outputData = (await this.apiService.save(
      newData
    )) as ResponseBase;
    const { Errors:errors,ServiceHeader: responseServiceHeader,ServiceMessage:responseServiceMessage } = outputData
    // On Success
    this.isLoading = false;
  

    if (responseServiceHeader && responseServiceHeader['Status'] == 'Success' || (responseServiceHeader && responseServiceHeader['Status'] == 'Failed' && (responseServiceMessage && (responseServiceMessage['ErrorCode']=='E015' || responseServiceMessage['ErrorCode']=='E014' )))) {
      this.verifyDocusignResponse = outputData;
    }else if(responseServiceMessage && responseServiceMessage.ErrorDescription) {
      this.globals.showErrorModal(responseServiceMessage.ErrorDescription);
      return true;
      // print error
    }else if(errors && errors.length>0){
      this.globals.showErrorModal("Internal Server Error");
    }

  

    
    return null;
  }
}

@Component({
  selector: 'app-review-and-submit',
  templateUrl: './review-and-submit.component.html',
  styleUrls: ['./review-and-submit.component.scss'],
})
export class ReviewAndSubmitComponent implements OnInit {
  model = new ReviewAndSubmitModel(this.globals, this.apiService, this.el);

  @ViewChild('modalDocusign', { static: false })
  modalDocusign: ElementRef | undefined;

  modalDocusignInstance: NgbModalRef | undefined;

  form: FormGroup = this.formBuilder.group({
    isAcknowledgeDeclaration: [false, [Validators.requiredTrue]],
    isAcknowledgeProductRisk: [false, [Validators.requiredTrue]],
    isAcknowledgeRiskDisclosure: [false, [Validators.requiredTrue]],
  });

  isRedirecting: boolean = false;

  constructor(
    private router: Router,
    public globals: GlobalsService,
    protected apiService: ApiService,
    private sideBarService: SideBarService,
    private formBuilder: FormBuilder,
    private el: ElementRef,
    private sharedAPIService : SharedAPIService,
    private modalService: NgbModal,
  ) {
    this.model.form = this.form;
    this.model.initializeForm = this.initializeForm;
    this.model.goToNextScreen = this.goToNextScreen;
    this.model.redirectToDocusign = this.redirectToDocusign;
    this.model.sharedAPIService = this.sharedAPIService
  }

  async ngOnInit() {
    console.log('[ReviewAndSubmitComponent] Page onInit');
    this.model.servlet_context_path = this.sharedAPIService.getServletContextPath()+"";
    await this.model.loadData();
    const redirectFromDocusign = window.localStorage.getItem('digital-fna-redirect-from-docusign')
     
    console.log(redirectFromDocusign)
    if(redirectFromDocusign && redirectFromDocusign!='null'){//this.sharedAPIService.getDocusignClicked()=='yes'){
      window.localStorage.setItem('digital-fna-redirect-from-docusign','');
      this.sharedAPIService.setDocusignClicked('')
      await this.model.onSubmit();

    }
  }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload($event: any) {
    if (!this.isRedirecting) {
      $event.returnValue =
        'Changes to your data will be lost! Are you sure you want to exit?';
    }
  }

  initializeForm = () => {
    this.isAcknowledgeDeclarationControl.setValue(
      this.model.isAcknowledgeDeclaration,
    );
    this.isAcknowledgeProductRiskControl.setValue(
      this.model.isAcknowledgeProductRisk,
    );
    this.isAcknowledgeRiskDisclosureControl.setValue(
      this.model.isAcknowledgeRiskDisclosure,
    );
  };

  goToNextScreen = async () => {
    console.log('[ReviewAndSubmitComponent] goToNextScreen');
    
    const { ServiceHeader: responseServiceHeader,ServiceMessage:responseServiceMessage } = this.model.verifyDocusignResponse
    
    if (responseServiceHeader && responseServiceHeader['Status'] == 'Success' ) {
      this.sharedAPIService.setDocusignStatus('Success');
    }else if((responseServiceHeader && responseServiceHeader['Status'] == 'Failed' && (responseServiceMessage && (responseServiceMessage['ErrorCode']=='E015' )))){
      this.sharedAPIService.setDocusignStatus('Failed');
    }else{
      this.sharedAPIService.setDocusignStatus('Pending');
    }
    await this.router.navigate(['/fna/confirmation'], {
      queryParams: { workflow: Workflow.FNA },
    });
  };

  redirectToDocusign = async () =>{
    
    this.modalDocusignInstance = this.modalService.open(
      this.modalDocusign,
      {
        backdrop: 'static',
        keyboard: false,
        scrollable: true,
      },
    );
  }

  handleAcceptDocusignRedirect() {
    this.modalDocusignInstance?.close();
    this.sharedAPIService.setDocusignClicked('yes')
    const docusignURL = this.model.submitResponseData.DocuSignEmbeddedURL
    this.sharedAPIService.setDocusignURL(docusignURL)
    window.location.href = docusignURL;
   
  }

  async handleLogout(){
    await this.model.callMiscService('R9999',{})
  }

  handleRejectDocusignRedirect() {
    this.modalDocusignInstance?.close();
    //this.router.navigateByUrl('/login');
  }

  goToPreviousScreen = async () => {
    console.log('[ReviewAndSubmitComponent] goToPreviousScreen');

    if ( !this.model.isAcceptAssessedRiskProfile) {
      await this.router.navigateByUrl('/fna/non-recommended-products');
      return;
    }

    await this.router.navigateByUrl('/fna/recommended-products');
  };

  async goToRiskAssessmentScreen() {
    await this.router.navigateByUrl('/fna/risk-profile-assessment');
  }

  async goToProductScreen() {
    await this.router.navigateByUrl('/fna/recommended-products');
  }

  // Form controls

  get isAcknowledgeDeclarationControl() {
    return this.form.get('isAcknowledgeDeclaration') as FormControl;
  }
  get isAcknowledgeProductRiskControl() {
    return this.form.get('isAcknowledgeProductRisk') as FormControl;
  }
  get isAcknowledgeRiskDisclosureControl() {
    return this.form.get('isAcknowledgeRiskDisclosure') as FormControl;
  }

  // Form controls end

  //region: getters

  get declaredNotEqualAssessed(): boolean {
    return riskDeclaredNotEqualRiskAssessed(
      this.model.declaredRiskProfile,
      this.model.assessedRiskProfile,
    );
  }

  get recommendedLowRiskOption() {
    return this.model.recommendedProducts.filter(
      (product) => { 
        return (product.riskLevel === 'low' && product.isChecked)},
    );
  }
  get recommendedModerateRiskOption() {
    let finalList = this.model.recommendedProducts.filter(
      
      (product) => {
        return (product.riskLevel === 'moderate' && product.isChecked)},
    );
    
    return finalList
  }
  get recommendedHighRiskOption() {
    return this.model.recommendedProducts.filter(
      (product) => {return (product.riskLevel === 'high' && product.isChecked)},
    );
  }

  get selectedNonRecommendedProducts() {
    return this.model.nonRecommendedProductsOptions.filter(
      (product) => product.isChecked,
    );
  }

  get selectedNonRecommendedLowRiskOption() {
    return this.selectedNonRecommendedProducts.filter(
      (product) => product.riskLevel === 'low',
    );
  }
  get selectedNonRecommendedModerateRiskOption() {
    return this.selectedNonRecommendedProducts.filter(
      (product) => product.riskLevel === 'moderate',
    );
  }
  get selectedNonRecommendedHighRiskOption() {
    return this.selectedNonRecommendedProducts.filter(
      (product) => product.riskLevel === 'high',
    );
  }
  get selectedNonRecommendedOthersOption() {
    return this.selectedNonRecommendedProducts.filter(
      (product) => product.riskLevel === 'others',
    );
  }

  get productDeclarationStatement() {
    if (
      !this.model.isAcceptRecommendedProducts ||
      !this.model.isAcceptAssessedRiskProfile
    ) {
      //statement for product B
      return 'We do not wish to accept the advice and/or recommendation(s) by the Treasury Advisor of the selected products set out in Table A. Instead, we wish to purchase other product(s) which is/are not recommended by the Treasury Advisor as selected by us in Table B. In respect of the following product(s) selected by us in Table B below, we understand and accept all risks, financial or otherwise, associated with such product(s) and have obtained separate and independent financial advice that such product(s) is/are suitable for us.';
    }

    if (this.model.isPurchaseTableBProducts) {
      //statement for product A & B
      return 'We understand and accept the advice and/or recommendation(s) of the selected products set out in Table A, which is/are based on information given by us in this FNA document. However, in addition, we wish to also purchase other product(s) which is/are not recommended by the Treasury Advisor as selected by us in Table B. In respect of the following product(s) selected by us in Table B below, we understand and accept all risks, financial or otherwise, associated with such product(s) and have obtained separate and independent financial advice that such product(s) is/are suitable for us.';
    }
    //statement for product A
    return 'We understand and accept the advice and/or recommendation(s) of the selected products set out in Table A, which is/are based on information given by us in this FNA document. We confirm that we do not wish to purchase another product which is not recommended by the Treasury Advisor.';
  }

  //endregion
}
